export const buildDatasourceAdf = (datasource, url) => {
  return {
    type: 'blockCard',
    attrs: {
      url,
      datasource
    }
  };
};